import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyFieldText: {
		id: 'issue-field-atlas-project-readview-full.atlas-project.empty-field-text',
		defaultMessage: 'Add project',
		description: 'Text to indicate that a given issue field has no value set',
	},
});
